/* Dekino – own smooth scroll (requestAnimationFrame). Native behavior:'smooth' does not move the page in this theme. */
(function () {
  var raf = null;
  function cancel() { if (raf) { cancelAnimationFrame(raf); raf = null; } }
  ['wheel', 'touchstart', 'keydown'].forEach(function (ev) { window.addEventListener(ev, cancel, { passive: true }); });
  window.dekinoScrollTo = function (targetY, duration) {
    cancel();
    var startY = window.scrollY, maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    var endY = Math.max(0, Math.min(targetY, maxY)), dist = endY - startY;
    var ms = duration || Math.min(900, Math.max(350, Math.abs(dist) * 0.35));
    var t0 = null, html = document.documentElement, prev = html.style.scrollBehavior, started = false;
    html.style.scrollBehavior = 'auto';
    /* background tab / stalled animation frames -> jump instantly so the click never "does nothing" */
    setTimeout(function () { if (!started) { cancel(); window.scrollTo(0, endY); html.style.scrollBehavior = prev; } }, 120);
    function step(ts) {
      started = true;
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / ms);
      var e = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
      window.scrollTo(0, startY + dist * e);
      if (p < 1) { raf = requestAnimationFrame(step); } else { raf = null; html.style.scrollBehavior = prev; }
    }
    raf = requestAnimationFrame(step);
  };
  window.dekinoScrollToEl = function (el, offset) {
    window.dekinoScrollTo(el.getBoundingClientRect().top + window.scrollY - (offset || 0));
  };
  /* theme's floating "scroll to top" button uses native smooth scroll -> take over */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.scroll-to-top-btn');
    if (b) { e.preventDefault(); e.stopImmediatePropagation(); window.dekinoScrollTo(0); }
  }, true);
})();

/* Dekino – odpočet do uzávěrky expedice (Europe/Prague) */
(function () {
  'use strict';
  var DAY_NAMES = { 1: 'v pondělí', 2: 'v úterý', 3: 've středu', 4: 've čtvrtek', 5: 'v pátek', 6: 'v sobotu', 0: 'v neděli' };
  var WEEKDAY_IDX = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  var fmt;
  try {
    fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Prague', hour: '2-digit', minute: '2-digit', second: '2-digit', weekday: 'short', hour12: false });
  } catch (e) { fmt = null; }

  function pragueNow() {
    var d = new Date();
    if (!fmt) return { h: d.getHours(), m: d.getMinutes(), s: d.getSeconds(), dow: d.getDay() };
    var out = { h: 0, m: 0, s: 0, dow: d.getDay() };
    fmt.formatToParts(d).forEach(function (p) {
      if (p.type === 'hour') out.h = parseInt(p.value, 10) % 24;
      else if (p.type === 'minute') out.m = parseInt(p.value, 10);
      else if (p.type === 'second') out.s = parseInt(p.value, 10);
      else if (p.type === 'weekday' && WEEKDAY_IDX.hasOwnProperty(p.value)) out.dow = WEEKDAY_IDX[p.value];
    });
    return out;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function nextDispatchDay(dow, weekdaysOnly) {
    if (!weekdaysOnly) return 'zítra';
    if (dow === 5) return 'v pondělí';
    if (dow === 6) return 'v pondělí';
    if (dow === 0) return 'v pondělí';
    return 'zítra';
  }
  function render(el) {
    var cutH = parseInt(el.getAttribute('data-cutoff-hour'), 10) || 14;
    var cutM = parseInt(el.getAttribute('data-cutoff-minute'), 10) || 0;
    var weekdaysOnly = el.getAttribute('data-weekdays-only') === 'true';
    var tToday = el.getAttribute('data-text-today') || '';
    var tNext = el.getAttribute('data-text-next') || '';
    var now = pragueNow();
    var timeStr = pad(cutH) + ':' + pad(cutM);
    var secsNow = now.h * 3600 + now.m * 60 + now.s;
    var secsCut = cutH * 3600 + cutM * 60;
    var isWeekend = now.dow === 0 || now.dow === 6;
    var html;
    if (!(weekdaysOnly && isWeekend) && secsNow < secsCut) {
      var rem = secsCut - secsNow;
      var h = Math.floor(rem / 3600), m = Math.floor((rem % 3600) / 60), s = rem % 60;
      var cd = '<span class="dekino-dispatch__timer">' + (h > 0 ? h + ' h ' : '') + pad(m) + ' min ' + pad(s) + ' s</span>';
      html = tToday.replace('[time]', timeStr).replace('[countdown]', cd);
    } else {
      html = tNext.replace('[day]', nextDispatchDay(now.dow, weekdaysOnly)).replace('[time]', timeStr);
    }
    var target = el.querySelector('.dekino-dispatch__text');
    if (target && target.innerHTML !== html) target.innerHTML = html;
  }
  function init() {
    var els = document.querySelectorAll('[data-dekino-dispatch]');
    if (!els.length) return;
    function tick() { for (var i = 0; i < els.length; i++) render(els[i]); }
    tick();
    setInterval(tick, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();

/* Dekino – sticky CTA on the homepage (mobile) */
(function () {
  'use strict';
  function initSticky() {
    var bar = document.querySelector('[data-dekino-sticky]');
    if (!bar) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    var anchor = document.getElementById('koupit');
    if (!form && !anchor) return;
    bar.hidden = false;
    var ticking = false;
    function update() {
      ticking = false;
      var ref = form || anchor;
      var r = ref.getBoundingClientRect();
      var passed = r.bottom < 0;
      var nearEnd = (window.innerHeight + window.scrollY) > (document.body.scrollHeight - 300);
      var vis = passed && !nearEnd;
      bar.classList.toggle('is-visible', vis);
      document.documentElement.style.setProperty('--dekino-sticky-offset', vis ? bar.offsetHeight + 'px' : '0px');
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
    var btn = bar.querySelector('[data-dekino-sticky-btn]');
    if (btn && anchor) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        window.dekinoScrollToEl(anchor, 10);
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky); else initSticky();
})();

/* --- Dekino videos: lazy load + autoplay only in viewport, tap to unmute --- */
(function () {
  var tracks = document.querySelectorAll('[data-dekino-videos]');
  if (!tracks.length) return;
  var saveData = navigator.connection && navigator.connection.saveData;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var all = [];
  function load(v) { if (!v.getAttribute('src') && v.dataset.src) { v.setAttribute('src', v.dataset.src); v.load(); } }
  function tryPlay(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function center(track) {
    var w = 0; [].forEach.call(track.children, function (c) { w += c.offsetWidth; });
    w += (track.children.length - 1) * 20;
    track.classList.toggle('is-centered', w + 100 < track.clientWidth);
  }
  tracks.forEach(function (track) {
    var vids = [].slice.call(track.querySelectorAll('video'));
    all = all.concat(vids);
    center(track); window.addEventListener('resize', function () { center(track); });
  });
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting && e.intersectionRatio >= 0.4) {
        if (saveData || reduced) return;
        load(v); tryPlay(v);
      } else if (!v.paused) { v.pause(); }
    });
  }, { threshold: [0, 0.4], rootMargin: '120px 0px' }) : null;
  all.forEach(function (v) {
    var frame = v.parentNode;
    var btn = frame.querySelector('[data-dekino-sound]');
    function setSound(on) {
      v.muted = !on; frame.classList.toggle('is-sound', on);
      if (btn) { btn.setAttribute('aria-pressed', on ? 'true' : 'false'); btn.setAttribute('aria-label', on ? 'Vypnout zvuk' : 'Zapnout zvuk'); }
    }
    function toggle() {
      var on = v.muted;
      if (on) { all.forEach(function (o) { if (o !== v && !o.muted) { o.muted = true; o.parentNode.classList.remove('is-sound'); var b = o.parentNode.querySelector('[data-dekino-sound]'); if (b) b.setAttribute('aria-pressed', 'false'); } }); }
      load(v); setSound(on);
      if (on) { try { v.currentTime = 0; } catch (err) {} }
      tryPlay(v);
    }
    if (btn) btn.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); toggle(); });
    v.addEventListener('click', toggle);
    v.addEventListener('playing', function () { frame.classList.add('is-playing'); });
    if (io) io.observe(v); else { load(v); }
  });
})();


/* --- Shopify Forms teaser ("Sleva 10 %") must not cover the sticky CTA on mobile --- */
(function () {
  var bar = document.querySelector('.dekino-sticky-cta');
  if (!bar) return;
  function apply() {
    var host = document.querySelector('shopify-forms-embed');
    if (!host || !host.shadowRoot) return false;
    var st = host.shadowRoot.getElementById('dekino-teaser-fix');
    if (!st) { st = document.createElement('style'); st.id = 'dekino-teaser-fix'; host.shadowRoot.appendChild(st); }
    var up = bar.classList.contains('is-visible') && window.innerWidth < 750;
    st.textContent = up ? '[class*="_teaserContainer"]{transform:translateY(-' + (bar.offsetHeight + 8) + 'px)!important;transition:transform .25s}' : '[class*="_teaserContainer"]{transition:transform .25s}';
    return true;
  }
  var tries = 0, timer = setInterval(function () { if (apply() || ++tries > 40) clearInterval(timer); }, 500);
  new MutationObserver(function () { apply(); }).observe(bar, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('resize', apply);
})();


/* --- "/#koupit"-style links: scroll within the current page when the anchor exists here (works on product page too) --- */
(function () {
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var m = href.match(/^\/?#([A-Za-z0-9_-]+)$/);
    if (!m) return;
    var el = document.getElementById(m[1]);
    if (!el) return;
    ev.preventDefault();
    window.dekinoScrollToEl(el, 0);
    if (history.replaceState) history.replaceState(null, '', '#' + m[1]);
  });
})();

/* --- Nulled Shrine "time bomb": CartItems sets this.lineItemContainer = formatDates(currentDate, date) (a date check, not an element).
   When false it (a) rewrites routes.cart_add_url to "cart" and (b) skips re-rendering the cart after quantity changes.
   Routes are locked in theme.liquid; here the flag is forced to true for existing and future instances. --- */
(function () {
  function force(name) {
    if (!('customElements' in window)) return;
    customElements.whenDefined(name).then(function () {
      var C = customElements.get(name);
      if (!C) return;
      try {
        Object.defineProperty(C.prototype, 'lineItemContainer', { get: function () { return true; }, set: function () {}, configurable: true });
      } catch (e) {}
      document.querySelectorAll(name).forEach(function (el) { try { delete el.lineItemContainer; } catch (e) {} });
    });
  }
  ['cart-items', 'cart-drawer-items'].forEach(force);
  if (typeof window.formatDates === 'function') { window.formatDates = function () { return true; }; }
  document.addEventListener('DOMContentLoaded', function () { if (typeof window.formatDates === 'function') { window.formatDates = function () { return true; }; } });
})();

/* --- Dekino pop-up: e-mail + code for the first order (replaces the Shopify Forms popup) --- */
(function () {
  var popup = document.querySelector('[data-dekino-popup]');
  if (!popup) return;
  var teaser = document.querySelector('[data-dekino-popup-teaser]');
  var form = popup.querySelector('form');
  var stepForm = popup.querySelector('[data-dekino-popup-step="form"]');
  var stepOk = popup.querySelector('[data-dekino-popup-step="success"]');
  var errEl = popup.querySelector('[data-dekino-popup-error]');
  var KEY = 'dekino_popup';
  var days = parseFloat(popup.dataset.days) || 7, delay = parseFloat(popup.dataset.delay) || 8, scrollPct = parseFloat(popup.dataset.scroll) || 35, exitIntent = popup.dataset.exit === 'true';
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function write(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  var st = read(), params = new URLSearchParams(location.search), opened = false, isOpen = false, lastFocus = null;
  function showTeaser(v) { if (teaser) teaser.hidden = !v; }
  function open(success) {
    if (isOpen) return; isOpen = true; opened = true;
    popup.hidden = false;
    void popup.offsetWidth; /* reflow so the opacity transition runs; no rAF (does not fire in background tabs) */
    popup.classList.add('is-open');
    document.documentElement.classList.add('dekino-popup-open');
    showTeaser(false);
    stepForm.hidden = !!success; stepOk.hidden = !success;
    lastFocus = document.activeElement;
    var f = success ? popup.querySelector('.dekino-popup__cta') : (window.innerWidth >= 750 ? popup.querySelector('input[type=email]') : popup.querySelector('.dekino-popup__close'));
    if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) {} }, 280);
  }
  function close() {
    if (!isOpen) return; isOpen = false;
    popup.classList.remove('is-open'); document.documentElement.classList.remove('dekino-popup-open');
    setTimeout(function () { popup.hidden = true; }, 250);
    if (!st.done) { st.closedAt = Date.now(); write(st); showTeaser(true); }
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  popup.querySelectorAll('[data-dekino-popup-close]').forEach(function (el) { el.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) close(); });
  if (teaser) teaser.addEventListener('click', function () { open(!!st.done); });
  popup.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(popup.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])'), function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  var copyBtn = popup.querySelector('[data-dekino-popup-copy]');
  if (copyBtn) copyBtn.addEventListener('click', function () {
    var code = popup.dataset.code;
    var done = function () { copyBtn.textContent = 'Zkopírováno ✓'; setTimeout(function () { copyBtn.textContent = 'Kopírovat'; }, 2000); };
    if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(done, done); }
    else { var t = document.createElement('textarea'); t.value = code; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (e) {} document.body.removeChild(t); done(); }
  });
  function success() {
    st.done = true; st.doneAt = Date.now(); st.pending = false; write(st);
    stepForm.hidden = true; stepOk.hidden = false; showTeaser(false);
    var f = popup.querySelector('.dekino-popup__cta'); if (f) { try { f.focus({ preventScroll: true }); } catch (e) {} }
  }
  /* Submit natively: Shopify's storefront spam protection (hCaptcha) hooks the real submit event, adds the token and posts the form.
     A fetch() or form.submit() would arrive without a token ("Missing CAPTCHA token"). After the redirect (?customer_posted=true)
     the pop-up reopens in the success state (st.pending). */
  if (form) form.addEventListener('submit', function (e) {
    var email = form.querySelector('input[type=email]');
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value || '')) { e.preventDefault(); if (errEl) errEl.hidden = false; if (email) email.focus(); return; }
    if (errEl) errEl.hidden = true;
    st.pending = true; st.pendingAt = Date.now(); write(st);
    var btn = form.querySelector('[type=submit]'), label = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Odesílám…'; }
    /* if the page has not navigated within 12 s (captcha blocked / offline), let the visitor try again */
    setTimeout(function () { if (btn) btn.textContent = label; if (errEl) { errEl.textContent = 'Odeslání se nepovedlo, zkus to prosím ještě jednou.'; errEl.hidden = false; } }, 12000);
  });
  if (params.get('customer_posted') === 'true' && st.pending && Date.now() - (st.pendingAt || 0) < 3600e3) { open(true); success(); }
  else if (params.get('dekino_popup') === '1') { open(!!st.done); }
  else if (st.done) { showTeaser(false); }
  else if (st.closedAt && Date.now() - st.closedAt < days * 864e5) { showTeaser(true); }
  else {
    var armed = true;
    function trigger() {
      if (!armed || opened) return;
      if (document.querySelector('cart-drawer.active, .menu-drawer.menu-opening')) { setTimeout(trigger, 4000); return; }
      var cookieBanner = document.querySelector('#shopify-pc__banner, .shopify-pc__banner, [id^="shopify-pc__"]');
      if (cookieBanner && cookieBanner.offsetParent !== null) { setTimeout(trigger, 2500); return; } /* wait until the cookie banner is answered */
      armed = false; open(false);
    }
    setTimeout(trigger, delay * 1000);
    window.addEventListener('scroll', function () { var h = document.documentElement.scrollHeight - window.innerHeight; if (h > 0 && (window.scrollY / h) * 100 >= scrollPct) trigger(); }, { passive: true });
    if (exitIntent && window.matchMedia('(hover: hover) and (pointer: fine)').matches) document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) trigger(); });
    showTeaser(false);
  }
})();
